//initial redux
import { put, call, takeEvery, fork, all, takeLatest, select, take } from "redux-saga/effects";
import { Interval, Point, PointDisplay } from "../../services/Live/types";
import { eventChannel, delay } from "redux-saga";
import evidenceservice from "../../services/evidence";
import { TreeFlatener, TreeMap, DateTime, AsyncSaga } from "../../utils";
import { types as sitetreetypes, actions as sitetreeactions} from "../../services/SiteTree/redux";
import moment from "moment";
import { ManualPromise } from "../../boot/http";
import * as router from "react-router-redux";
import { actions as chartActions } from "../../components/EvidenceComponents/Chart/redux";
import { actions as listActions } from "../../components/EvidenceComponents/List/redux";
import { types as searchtypes } from "../../components/SearchBar/redux";
import { actions as searchactions } from "../../components/SearchBar/redux";

const initialState = {
	calendarOpen: false,

	pst_description: "",
	pst_descriptions: [{startDate: null, description: ""}, {startDate: null, description: ""}],
	viewId: null,
	forceRecalc: false,
	ic_isDays: true,
	pst_isDays: true,
	pst_length: 1,

	showingDataType: "List",
	ic_compareType: null,
	ic_comparisonId: null,
	rerender: 0,

	searchValue: "AutomatedActions",
	searchText: "",
	hasSearched: false,
	searchResults: 0,
	isSearchBusy: false,
};

/////////
//types
export const types = {
	TOGGLE_CALENDAR: "screens/Evidence/Chart/TOGGLE_CALENDAR",
	TOGGLE_OPEN_CATEGORY: "screens/Evidence/Chart/TOGGLE_OPEN_CATEGORY",
	TOGGLE_OPEN_RULE: "screens/Evidence/Chart/TOGGLE_OPEN_RULE",

	SAVE_IMPLEMENTED_CHANGE: "screens/Evidence/Chart/SAVE_IMPLEMENTED_CHANGE",
	ON_SAVE_IMPLEMENTED_CHANGE: "screens/Evidence/Chart/ON_SAVE_IMPLEMENTED_CHANGE",
	ON_SAVE_IMPLEMENTED_CHANGE_FAILED: "screens/Evidence/Chart/ON_SAVE_IMPLEMENTED_CHANGE_FAILED",
	SAVE_COMMENT: "screens/Evidence/Chart/SAVE_COMMENT",
	ON_SAVE_COMMENT: "screens/Evidence/Chart/ON_SAVE_COMMENT",
	ON_SAVE_COMMENT_FAILED: "screens/Evidence/Chart/ON_SAVE_COMMENT_FAILED",
	SAVE_PRE_SET_TESTS: "screens/Evidence/Chart/SAVE_PRE_SET_TESTS",
	ON_SAVE_PRE_SET_TESTS: "screens/Evidence/Chart/ON_SAVE_PRE_SET_TESTS",
	ON_SAVE_PRE_SET_TESTS_FAILED: "screens/Evidence/Chart/ON_SAVE_PRE_SET_TESTS_FAILED",

	RESET_IMPLEMENTED_CHANGE: "screens/Evidence/Chart/RESET_IMPLEMENTED_CHANGE",
	RESET_COMMENT: "screens/Evidence/Chart/RESET_COMMENT",
	RESET_PRE_SET_TESTS: "screens/Evidence/Chart/RESET_PRE_SET_TESTS",

	SET_IMPLEMENTED_CHANGE_TIME: "screens/Evidence/Chart/SET_IMPLEMENTED_CHANGE_TIME",
	SET_IMPLEMENTED_CHANGE_DATE: "screens/Evidence/Chart/SET_IMPLEMENTED_CHANGE_DATE",
	SET_IMPLEMENTED_CHANGE_DESCRIPTION: "screens/Evidence/Chart/SET_IMPLEMENTED_CHANGE_DESCRIPTION",
	SET_IMPLEMENTED_CHANGE_LENGTH: "screens/Evidence/Chart/SET_IMPLEMENTED_CHANGE_LENGTH",
	SET_IMPLEMENTED_CHANGE_IS_DAYS: "screens/Evidence/Chart/SET_IMPLEMENTED_CHANGE_IS_DAYS",
	SET_IMPLEMENTED_CHANGE_VIEW_ID: "screens/Evidence/Chart/SET_IMPLEMENTED_CHANGE_VIEW_ID",
	ON_SET_IMPLEMENTED_CHANGE_VIEW_ID: "screens/Evidence/Chart/ON_SET_IMPLEMENTED_CHANGE_VIEW_ID",
	SET_IMPLEMENTED_CHANGE_COMPARISON_ID: "screens/Evidence/Chart/SET_IMPLEMENTED_CHANGE_COMPARISON_ID",
	ON_SET_IMPLEMENTED_CHANGE_COMPARISON_ID: "screens/Evidence/Chart/ON_SET_IMPLEMENTED_CHANGE_COMPARISON_ID",
	SET_IMPLEMENTED_CHANGE_COMPARE_TYPE: "screens/Evidence/Chart/SET_IMPLEMENTED_CHANGE_COMPARE_TYPE",
	ON_SET_IMPLEMENTED_CHANGE_COMPARE_TYPE: "screens/Evidence/Chart/ON_SET_IMPLEMENTED_CHANGE_COMPARE_TYPE",
	
	REVERSE_SET_IMPLEMENTED_CHANGE_VIEW_ID: "screens/Evidence/Chart/REVERSE_SET_IMPLEMENTED_CHANGE_VIEW_ID",
	REVERSE_SET_IMPLEMENTED_CHANGE_COMPARISON_ID: "screens/Evidence/Chart/REVERSE_SET_IMPLEMENTED_CHANGE_COMPARISON_ID",
	REVERSE_SET_IMPLEMENTED_CHANGE_COMPARE_TYPE: "screens/Evidence/Chart/REVERSE_SET_IMPLEMENTED_CHANGE_COMPARE_TYPE",
	REVERSE_SET_IMPLEMENTED_CHANGE_DESCRIPTION: "screens/Evidence/Chart/REVERSE_SET_IMPLEMENTED_CHANGE_DESCRIPTION",
	REVERSE_SET_IMPLEMENTED_CHANGE_TIME: "screens/Evidence/Chart/REVERSE_SET_IMPLEMENTED_CHANGE_TIME",
	REVERSE_SET_IMPLEMENTED_CHANGE_LENGTH: "screens/Evidence/Chart/REVERSE_SET_IMPLEMENTED_CHANGE_LENGTH",

	SET_COMMENT_TIME: "screens/Evidence/Chart/SET_COMMENT_TIME",
	SET_COMMENT_DATE: "screens/Evidence/Chart/SET_COMMENT_DATE",
	SET_COMMENT_DESCRIPTION: "screens/Evidence/Chart/SET_COMMENT_DESCRIPTION",
	SET_PRE_SET_TEST_DATE: "screens/Evidence/Chart/SET_PRE_SET_TEST_DATE",
	SET_PRE_SET_TEST_LENGTH: "screens/Evidence/Chart/SET_PRE_SET_TEST_LENGTH",
	SET_PRE_SET_TEST_IS_DAYS: "screens/Evidence/Chart/SET_PRE_SET_TEST_IS_DAYS",
	SET_PRE_SET_TEST_OCCURS: "screens/Evidence/Chart/SET_PRE_SET_TEST_OCCURS",
	SET_PRE_SET_TEST_DESCRIPTION: "screens/Evidence/Chart/SET_PRE_SET_TEST_DESCRIPTION",
	SET_PRE_SET_TEST_DESCRIPTIONS: "screens/Evidence/Chart/SET_PRE_SET_TEST_DESCRIPTIONS",
	ON_SET_PRE_SET_TEST_OCCURS: "screens/Evidence/Chart/ON_SET_PRE_SET_TEST_OCCURS",
	ON_SET_PRE_SET_TEST_DESCRIPTIONS: "screens/Evidence/Chart/ON_SET_PRE_SET_TEST_DESCRIPTIONS",
	SET_PRE_SET_DESCRIPTIONS_DATE: "screens/Evidence/Chart/SET_PRE_SET_DESCRIPTIONS_DATE",
	ON_SET_PRE_SET_DESCRIPTIONS_DATE: "screens/Evidence/Chart/ON_SET_PRE_SET_DESCRIPTIONS_DATE",
	SET_PRE_SET_TEST_VIEW_ID: "screens/Evidence/Chart/SET_PRE_SET_TEST_VIEW_ID",
	ON_SET_PRE_SET_TEST_VIEW_ID: "screens/Evidence/Chart/ON_SET_PRE_SET_TEST_VIEW_ID",
	REVERSE_SET_PRE_SET_TEST_VIEW_ID: "screens/Evidence/Chart/REVERSE_SET_PRE_SET_TEST_VIEW_ID",

	CHANGE_SHOWING_DATA_TYPE: "screens/Evidence/Chart/CHANGE_SHOWING_DATA_TYPE",
	RERENDER: "screens/Evidence/Chart/RERENDER",
	RECALCULATE_DESCRIPTION_DATES: "screens/Evidence/Chart/RECALCULATE_DESCRIPTION_DATES",
	ON_RECALCULATE_DESCRIPTION_DATES: "screens/Evidence/Chart/ON_RECALCULATE_DESCRIPTION_DATES",
	SET_FORCE_RECALC: "screens/Evidence/Chart/SET_FORCE_RECALC",

	DELETE_COMMENT: "screens/Evidence/Chart/DELETE_COMMENT",
	ON_DELETE_COMMENT: "screens/Evidence/Chart/ON_DELETE_COMMENT",
	ON_DELETE_COMMENT_FAILED: "screens/Evidence/Chart/ON_DELETE_COMMENT_FAILED",
	DELETE_IMPLEMENTED_CHANGE: "screens/Evidence/Chart/DELETE_IMPLEMENTED_CHANGE",
	ON_DELETE_IMPLEMENTED_CHANGE: "screens/Evidence/Chart/ON_DELETE_IMPLEMENTED_CHANGE",
	ON_DELETE_IMPLEMENTED_CHANGE_FAILED: "screens/Evidence/Chart/ON_DELETE_IMPLEMENTED_CHANGE_FAILED",
	DELETE_PRE_SET_TEST: "screens/Evidence/Chart/DELETE_PRE_SET_TEST",
	ON_DELETE_PRE_SET_TEST: "screens/Evidence/Chart/ON_DELETE_PRE_SET_TEST",
	ON_DELETE_PRE_SET_TEST_FAILED: "screens/Evidence/Chart/ON_DELETE_PRE_SET_TEST_FAILED",

	SET_SEARCH_VALUE: "screens/Evidence/Chart/SET_SEARCH_VALUE",
	SET_SEARCH_TEXT: "screens/Evidence/Chart/SET_SEARCH_TEXT",
	CLEAR_SEARCH: "screens/Evidence/Chart/CLEAR_SEARCH",
	SEARCH: "screens/Evidence/Chart/SEARCH",
	ON_SEARCH: "screens/Evidence/Chart/ON_SEARCH",
	SET_SEARCH_BUSY: "screens/Evidence/Chart/SET_SEARCH_BUSY",

	CLEAR_MODAL_DATA: "screens/Evidence/Chart/CLEAR_MODAL_DATA",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.TOGGLE_CALENDAR:
				return { ...state, calendarOpen: !state.calendarOpen };

			case types.SAVE_IMPLEMENTED_CHANGE:
				return { ...state, isBusy: true }
			case types.RESET_IMPLEMENTED_CHANGE:
				return { ...state, ic_time: "00:00", ic_comparisonId: null, ic_compareType: null, ic_date: new Date(Date.now()), ic_description: "", viewId: null, editDto: null}
			case types.SAVE_COMMENT:
				return { ...state, isBusy: true }
			case types.RESET_COMMENT:
				return { ...state, co_time: "00:00", co_date: new Date(Date.now()), co_description: "", editDto: null}
			case types.SAVE_PRE_SET_TESTS:
				return { ...state, isBusy: true }
			case types.RESET_PRE_SET_TESTS:
				return { ...state, pst_date: new Date(Date.now()), pst_length: 1, pst_isDays: true, pst_occurs: 2, pst_description: "", pst_descriptions: [{startDate: null, description: ""}, {startDate: null, description: ""}], viewId: null, editDto: null }

			case types.SET_IMPLEMENTED_CHANGE_TIME:
				return { ...state, ic_time: action.payload }
			case types.SET_IMPLEMENTED_CHANGE_DATE:
				return { ...state, ic_date: action.payload }
			case types.SET_IMPLEMENTED_CHANGE_DESCRIPTION:
				return { ...state, ic_description: action.payload }
			case types.SET_IMPLEMENTED_CHANGE_LENGTH:
				return { ...state, ic_length: action.payload }
			case types.SET_IMPLEMENTED_CHANGE_IS_DAYS:
				return { ...state, ic_isDays: action.payload }
			case types.ON_SET_IMPLEMENTED_CHANGE_VIEW_ID:
				return { ...state, viewId: action.payload }
			case types.ON_SET_IMPLEMENTED_CHANGE_COMPARISON_ID:
				return { ...state, ic_comparisonId: action.payload }
			case types.ON_SET_IMPLEMENTED_CHANGE_COMPARE_TYPE:
				return { ...state, ic_compareType: action.payload }
			case types.SET_COMMENT_TIME:
				return { ...state, co_time: action.payload }
			case types.SET_COMMENT_DATE:
				return { ...state, co_date: action.payload }
			case types.SET_COMMENT_DESCRIPTION:
				return { ...state, co_description: action.payload }
			case types.SET_PRE_SET_TEST_DATE:
				return { ...state, pst_date: action.payload }
			case types.SET_PRE_SET_TEST_LENGTH:
				return { ...state, pst_length: action.payload }
			case types.SET_PRE_SET_TEST_IS_DAYS:
				return { ...state, pst_isDays: action.payload }
			case types.SET_PRE_SET_TEST_DESCRIPTION:
				return { ...state, pst_description: action.payload }
			case types.ON_SET_PRE_SET_TEST_OCCURS:
				return { ...state, pst_occurs: action.payload }
			case types.ON_SET_PRE_SET_DESCRIPTIONS_DATE:
			case types.ON_SET_PRE_SET_TEST_DESCRIPTIONS:
				return { ...state, pst_descriptions: action.payload }
			case types.ON_SET_PRE_SET_TEST_VIEW_ID:
				return { ...state, viewId: action.payload }
			case types.CHANGE_SHOWING_DATA_TYPE:
				return { ...state, showingDataType: action.payload }
			case types.ON_RECALCULATE_DESCRIPTION_DATES:
				return { ...state, forceRecalc: false };
			case types.SET_FORCE_RECALC:
				return { ...state, forceRecalc: true };

			case types.SET_SEARCH_VALUE:
				return { ...state, searchValue: action.payload}
			case types.SET_SEARCH_TEXT:
				return { ...state, searchText: action.payload}
			case types.CLEAR_SEARCH:
				return { ...state, hasSearched: false, searchResults: 0}
			case types.SEARCH:
				return { ...state, isSearchBusy: true}
			case types.SET_SEARCH_BUSY:
				return { ...state, isSearchBusy: true}
			case types.ON_SEARCH:
				return { ...state, hasSearched: true, searchResults: action.payload, isSearchBusy: false}

			case types.RERENDER:
				return { ...state, rerender: state.rerender += 1 }

			default:
				return state;
		}
	}
};

/**
 * Returns the date of the next day. If today is friday and we are asking for next friday the friday of the next week is returned.
 * @param dayOfWeek 0:Su,1:Mo,2:Tu,3:We,4:Th,5:Fr,6:Sa
 */
function getNextDayOfWeek(date, dayOfWeek) {
	var resultDate = new Date(date.getTime());
	resultDate.setDate(date.getDate() + (7 + dayOfWeek - date.getDay() - 1) % 7 +1);
	return resultDate;
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([
			this.onSetPreSetTestDescriptions(),
			this.onSaveImplementedChange(),
			this.onSaveComment(),
			this.onSavePreSetTests(),
			this.onSetPreSetTestOccurs(),
			this.onSetPreSetTestViewId(),
			this.onSetImplementedChangeViewId(),
			this.onSetPreSetTestLength(),
			this.onRecalculateDescriptionDates(),
			this.onSetPreSetTestIsDays(),
			this.onSetPreSetTestDescriptionsDate(),
			this.onSetImplementedChangeComparisonId(),
			this.onSetImplementedChangeCompareType(),
			this.onReverseSetImplementedChangeCompareType(),
			this.onReverseSetImplementedChangeComparisonId(),
			this.onReverseSetImplementedChangeDescription(),
			this.onReverseSetImplementedChangeLength(),
			this.onReverseSetImplementedChangeTime(),
			this.onReverseSetImplementedChangeViewId(),
			this.onReverseSetPreSetTestViewId(),
			this.onDeleteImplementedChange(),
			this.onDeletePreSetTest(),
			this.onDeleteComment(),

			this.onSearchUpdate(),
			this.onSetSearchValue(),
			
			this.onClearModalData(),
		]);
	},

	*onClearModalData() {
		yield takeEvery(types.CLEAR_MODAL_DATA, function*() {
			yield put(actions.resetImplementedChanges());
			yield put(actions.resetComment());
			yield put(actions.resetPreSetTests());
		});
	},

	*onSetSearchValue() {
		yield takeEvery(types.SET_SEARCH_VALUE, function*({payload}) {
			const { searchText, hasSearched } = yield select(x => x.evidenceChart);

			if(hasSearched) {
				yield put(searchactions.searchSubmit({text: searchText, searchBarId: "evidence/List"}));
			}
		});
	},

	*onSearchUpdate() {
		yield takeEvery([searchtypes.SEARCH_BAR_UPDATED], function*({payload}) {
			if(payload.searchBarId !== undefined) {
				if (payload.searchBarId === "evidence/List") {
					let searchText = payload.query;
					yield put(actions.setSearchText(searchText));
				}
			}
		});
	},

	*onDeleteImplementedChange() {
		yield takeEvery(types.DELETE_IMPLEMENTED_CHANGE, function*({payload}) {
			let response = yield call(evidenceservice.DeleteImplementedChange, payload);
			if(response instanceof Error) {
				yield put(actions.genericAction(types.ON_DELETE_IMPLEMENTED_CHANGE_FAILED, response));
			} else {
				yield put(actions.genericAction(types.ON_DELETE_IMPLEMENTED_CHANGE));
				yield put(chartActions.resetCurrentLoaded());
				yield put(listActions.deleteImplementedChange(payload));
				yield put(actions.rerender());
			}
		});
	},

	*onDeletePreSetTest() {
		yield takeEvery(types.DELETE_PRE_SET_TEST, function*({payload}) {
			let response = yield call(evidenceservice.DeletePreSetTest, payload);
			if(response instanceof Error) {
				yield put(actions.genericAction(types.ON_DELETE_PRE_SET_TEST_FAILED, response));
			} else {
				yield put(actions.genericAction(types.ON_DELETE_PRE_SET_TEST));
				yield put(chartActions.resetCurrentLoaded());
				yield put(listActions.deletePreSetTest(payload));
				yield put(actions.rerender());
			}
		});
	},

	*onDeleteComment() {
		yield takeEvery(types.DELETE_COMMENT, function*({payload}) {
			let response = yield call(evidenceservice.DeleteComment, payload);
			if(response instanceof Error) {
				yield put(actions.genericAction(types.ON_DELETE_COMMENT_FAILED, response));
			} else {
				yield put(actions.genericAction(types.ON_DELETE_COMMENT));
				yield put(chartActions.resetCurrentLoaded());
				yield put(listActions.deleteComment(payload));
				yield put(actions.rerender());
			}
		});
	},

	*onSetPreSetTestDescriptions() {
		yield takeEvery([types.SET_PRE_SET_TEST_DESCRIPTIONS], function*({payload}){
			//TODO: Add takeLatest here to optimise
			const { index, description } = payload;
			const evidenceChart = yield select(x => x.evidenceChart);
			let descriptions = [];

			for(let ii = 0; ii < evidenceChart.pst_descriptions.length; ii++) {
				if(ii === index) {
					descriptions.push({...evidenceChart.pst_descriptions[ii], description: description})
				} else {
					descriptions.push(evidenceChart.pst_descriptions[ii]);
				}
			}
			
			yield put(actions.onSetPreSetTestDescriptions(descriptions));
		});
	},

	*onSetPreSetTestDescriptionsDate() {
		yield takeEvery([types.SET_PRE_SET_DESCRIPTIONS_DATE], function*({payload}) {
			const { index, date } = payload;
			const evidenceChart = yield select(x => x.evidenceChart);
			let newDescriptions = [];

			evidenceChart.pst_descriptions.forEach((desc, ii) => {
				if(ii === index) {
					newDescriptions.push({...desc, startDate: date});
				} else {
					newDescriptions.push({...desc});
				}
			});

			yield put(actions.onSetPreSetTestDescriptionsDate(newDescriptions));
			yield put(actions.recalculateDescriptionDates());
		});
	},

	*onSaveImplementedChange() {
		yield takeEvery([types.SAVE_IMPLEMENTED_CHANGE], function*({payload}) {
			let evidenceChart = yield select(x => x.evidenceChart);
			const { ic_time, ic_date, ic_description, ic_length, ic_isDays, viewId, ic_comparisonId, ic_compareType } = evidenceChart;
			const sites = yield select(x => x.sitetree);
			
			const newIC = {siteName: sites.currentSite.name, time: ic_time, date: ic_date, description: ic_description, length: ic_length, isDays: ic_isDays, iEnergyViewId: viewId, comparisonId: ic_comparisonId, compareType: ic_compareType };
				
			let data = null;
			if(payload !== undefined && payload !== null) {
				data = yield call(evidenceservice.UpdateImplementedChange, newIC, payload);
			} else {
				data = yield call(evidenceservice.AddNewImplementedChange, newIC);
			}

			if(data instanceof Error) {
				yield put(actions.genericAction(types.ON_SAVE_IMPLEMENTED_CHANGE_FAILED, Error));
			} else {
				yield put(actions.onSaveImplementedChange(data));
				yield put(chartActions.resetCurrentLoaded());
				yield put(listActions.resetCurrentLoaded());
				yield put(actions.rerender());
			}
		});
	},

	*onSaveComment() {
		yield takeEvery([types.SAVE_COMMENT], function*({payload}) {
			let evidenceChart = yield select(x => x.evidenceChart);
			const { co_time, co_date, co_description } = evidenceChart;

			const sites = yield select(x => x.sitetree);
			const newCO = {siteName: sites.currentSite.name, time: co_time, date: co_date, description: co_description };
			
			let data = null;
			if(payload !== undefined && payload !== null) {
				data = yield call(evidenceservice.UpdateComment, newCO, payload);
			} else {
				data = yield call(evidenceservice.AddNewComment, newCO);	
			}

			if(data instanceof Error) {
				yield put(actions.genericAction(types.ON_SAVE_IMPLEMENTED_CHANGE_FAILED, Error));
			} else {
				yield put(actions.onSaveComment(data));
				yield put(chartActions.resetCurrentLoaded());
				yield put(listActions.resetCurrentLoaded());
				yield put(actions.rerender());
			}
		});
	},

	*onSavePreSetTests() {
		yield takeEvery([types.SAVE_PRE_SET_TESTS], function*({payload}) {
			let state = yield select();
			const { pst_length, pst_isDays, pst_occurs, pst_description, pst_descriptions, viewId } = state.evidenceChart;
			const { currentSite } = state.sitetree;

			let dateArray = [];
			let descriptionArray = [];
			pst_descriptions.forEach((desc) => {
				dateArray.push(desc.startDate);
				descriptionArray.push(desc.description);
			});
			if(dateArray.length === 0) {
				dateArray.push(Date.UTC());
			}
			
			const newPST = {siteName: currentSite.name, date: dateArray[0], length: pst_length, isDays: pst_isDays, occurs: pst_occurs, description: pst_description, descriptions: descriptionArray, dates: dateArray, iEnergyViewId: viewId}
			
			let data = null;
			if(payload !== undefined && payload !== null) {
				data = yield call(evidenceservice.UpdatePreSetTest, newPST, payload);
			} else {
				data = yield call(evidenceservice.AddNewPreSetTests, newPST);
			}

			if(data instanceof Error) {
				yield put(actions.genericAction(types.ON_SAVE_PRE_SET_TESTS_FAILED, Error));
			} else {
				yield put(actions.onSavePreSetTests(data));
				yield put(chartActions.resetCurrentLoaded());
				yield put(listActions.resetCurrentLoaded());
				yield put(actions.rerender());
			}
		});
	},

	*onSetPreSetTestOccurs() {
		yield takeEvery([types.SET_PRE_SET_TEST_OCCURS], function*({payload}) {
			let pst_descriptions = yield select(x => x.evidenceChart.pst_descriptions);

			if(pst_descriptions.length === payload) {
				yield put(actions.onSetPreSetTestOccurs(payload));
			} else {
				let newDescriptions = [];
				for(var ii = 0; ii < payload; ii++) {
					if(pst_descriptions !== null && pst_descriptions[ii] !== undefined) {
						newDescriptions.push(pst_descriptions[ii]);
					} else {
						newDescriptions.push({startDate: null, description: ""});
					}
				}

				yield put(actions.onSetPreSetTestOccurs(payload));
				yield put(actions.onSetPreSetTestDescriptions(newDescriptions));
			}

			yield put(actions.setForceRecalc());
			yield put(actions.recalculateDescriptionDates());
		});
	},

	*onSetPreSetTestLength() {
		yield takeEvery([types.SET_PRE_SET_TEST_LENGTH], function*({payload}) {
			yield put(actions.setForceRecalc());
			yield put(actions.recalculateDescriptionDates());
		});
	},

	*onSetPreSetTestIsDays() {
		yield takeEvery([types.SET_PRE_SET_TEST_IS_DAYS], function*({payload}) {
			yield put(actions.setForceRecalc());
			yield put(actions.recalculateDescriptionDates());
		});
	},

	*onRecalculateDescriptionDates() {
		yield takeEvery([types.RECALCULATE_DESCRIPTION_DATES], function*({payload}) {
			let evidenceChart = yield select(x => x.evidenceChart);
			const { pst_occurs, pst_length, pst_descriptions, pst_isDays, forceRecalc } = evidenceChart;

			if(pst_occurs && pst_length && pst_occurs > 1) {
				if(pst_descriptions && pst_descriptions[0] && pst_descriptions[0].startDate != null) {
					let dateCount = 0;

					pst_descriptions.forEach((desc, index) => {
						if(desc.startDate !== null) {
							dateCount++;
						}
					});

					let shouldRecalculate = forceRecalc ? true : dateCount !== pst_descriptions.length;

					if(shouldRecalculate) {
						let newDescriptions = [];

						let startDay = pst_descriptions[0].startDate.getDay();
						let currentDate = null;
						if(parseInt(pst_length, 10) > 1) {
							currentDate = moment(pst_descriptions[0].startDate).add((pst_isDays ? (parseInt(pst_length, 10) - 1) : ((parseInt(pst_length, 10) * 7) - 1)), "days").endOf("day").toDate();
						} else {
							currentDate = pst_descriptions[0].startDate;
						}
						newDescriptions.push({...pst_descriptions[0]});

						for(var ii = 1; ii < pst_descriptions.length; ii++) {
							let nextDay = null;
							if(parseInt(pst_length, 10) > 1) {
								nextDay = getNextDayOfWeek(currentDate, startDay);
								currentDate = moment(nextDay).add((pst_isDays ? (parseInt(pst_length, 10) - 1) : ((parseInt(pst_length, 10) * 7) - 1)), "days").endOf("day").toDate();
							} else {
								nextDay = moment(currentDate).add(1, "day").toDate();
								currentDate = nextDay;
							}
							
							newDescriptions.push({...pst_descriptions[ii], startDate: nextDay});
						}

						yield put(actions.onSetPreSetTestDescriptions(newDescriptions));
						yield put(actions.onRecalculateDescriptionDates());
					}
				}
			}
		});
	},

	*onSetPreSetTestViewId() {
		yield takeEvery([types.SET_PRE_SET_TEST_VIEW_ID], function*({payload}) {
			let viewId = document.getElementById(payload.htmlId).value;
			if(viewId === payload.defaultValue) {
				viewId = null;
			} 

			yield put(actions.onSetPreSetTestViewId(viewId));
		});
	},

	*onReverseSetPreSetTestViewId() {
		yield takeEvery(types.REVERSE_SET_PRE_SET_TEST_VIEW_ID, function*({payload}) {
			yield delay(1000);
			let doc = document.getElementById(payload.htmlId);
			if(payload.value) {
				doc.value = payload.value;
				yield put(actions.onSetPreSetTestViewId(payload.htmlId, payload.value));
			} else {
				doc.value = "-1";
				yield put(actions.onSetPreSetTestViewId(null));
			}
		});
	},

	*onSetImplementedChangeViewId() {
		yield takeEvery([types.SET_IMPLEMENTED_CHANGE_VIEW_ID], function*({payload}) {
			let viewId = document.getElementById(payload.htmlId).value;
			if(viewId === payload.defaultValue) {
				viewId = null;
			} 

			yield put(actions.onSetImplementedChangeViewId(viewId));
		});
	},

	*onReverseSetImplementedChangeViewId() {
		yield takeEvery(types.REVERSE_SET_IMPLEMENTED_CHANGE_VIEW_ID, function*({payload}) {
			yield delay(1000);
			let doc = document.getElementById(payload.htmlId);
			if(payload.value) {
				doc.value = payload.value;
				yield put(actions.onSetImplementedChangeViewId(payload.value));
			} else {
				doc.value = "-1";
				yield put(actions.onSetImplementedChangeViewId(null));
			}
		});
	},

	*onSetImplementedChangeComparisonId() {
		yield takeEvery([types.SET_IMPLEMENTED_CHANGE_COMPARISON_ID], function*({payload}) {
			let viewId = document.getElementById(payload.htmlId).value;
			if(viewId === payload.defaultValue) {
				viewId = null;
			} 

			yield put(actions.onSetImplementedChangeComparisonId(viewId));
		});
	},

	*onReverseSetImplementedChangeComparisonId() {
		yield takeEvery(types.REVERSE_SET_IMPLEMENTED_CHANGE_COMPARISON_ID, function*({payload}) {
			yield delay(1000);
			let doc = document.getElementById(payload.htmlId);
			if(payload.value) {
				doc.value = payload.value;
				yield put(actions.onSetImplementedChangeComparisonId(payload.value));
			} else {
				doc.value = "-1";
				yield put(actions.onSetImplementedChangeComparisonId(null));
			}
		});
	},
	
	*onSetImplementedChangeCompareType() {
		yield takeEvery([types.SET_IMPLEMENTED_CHANGE_COMPARE_TYPE], function*({payload}) {
			let value = document.getElementById(payload.htmlId).value;
			if(value === payload.defaultValue) {
				value = null;
			} 

			yield put(actions.onSetImplementedChangeCompareType(value));
		});
	},

	*onReverseSetImplementedChangeCompareType() {
		yield takeEvery(types.REVERSE_SET_IMPLEMENTED_CHANGE_COMPARE_TYPE, function*({payload}) {
			yield delay(1000);
			let doc = document.getElementById(payload.htmlId);
			if(payload.value) {
				doc.value = payload.value;
				yield put(actions.onSetImplementedChangeCompareType(payload.value));
			} else {
				doc.value = "-1";
				yield put(actions.onSetImplementedChangeCompareType(null));
			}
		});
	},
	
	*onReverseSetImplementedChangeDescription() {
		yield takeEvery(types.REVERSE_SET_IMPLEMENTED_CHANGE_DESCRIPTION, function*({payload}) {
			yield put(actions.setImplementedChangeDescription(payload.value));
		});
	},
	*onReverseSetImplementedChangeTime() {
		yield takeEvery(types.REVERSE_SET_IMPLEMENTED_CHANGE_TIME, function*({payload}) {
			yield delay(1000);
			let doc = document.getElementById(payload.htmlId);
			doc.value = payload.value;

			yield put(actions.setImplementedChangeTime(payload.value));
		});
	},
	*onReverseSetImplementedChangeLength() {
		yield takeEvery(types.REVERSE_SET_IMPLEMENTED_CHANGE_LENGTH, function*({payload}) {
			yield delay(1000);
			let doc = document.getElementById(payload.htmlId);
			doc.value = payload.value;

			yield put(actions.setImplementedChangeLength(payload.value));
		});
	},
};

////////
//actions
export const actions = {

	toggleCalendar() {
		return {
			type: types.TOGGLE_CALENDAR,
			payload: {}
		};
	},
	saveImplementedChange(payload) {
		return {
			type: types.SAVE_IMPLEMENTED_CHANGE,
			payload
		}
	},
	saveComment(payload) {
		return {
			type: types.SAVE_COMMENT,
			payload
		}
	},
	savePreSetTests(payload) {
		return {
			type: types.SAVE_PRE_SET_TESTS,
			payload
		}
	},

	setImplementedChangeTime(payload){
		return {
			type: types.SET_IMPLEMENTED_CHANGE_TIME,
			payload
		}
	},
	setImplementedChangeDate(payload){
		return {
			type: types.SET_IMPLEMENTED_CHANGE_DATE,
			payload
		}
	},
	setImplementedChangeDescription(payload){
		return {
			type: types.SET_IMPLEMENTED_CHANGE_DESCRIPTION,
			payload
		}
	},
	setImplementedChangeLength(payload){
		return {
			type: types.SET_IMPLEMENTED_CHANGE_LENGTH,
			payload
		}
	},
	setImplementedChangeIsDays(payload){
		return {
			type: types.SET_IMPLEMENTED_CHANGE_IS_DAYS,
			payload
		}
	},
	setCommentTime(payload){
		return {
			type: types.SET_COMMENT_TIME,
			payload
		}
	},
	setCommentDate(payload){
		return {
			type: types.SET_COMMENT_DATE,
			payload
		}
	},
	setCommentDescription(payload){
		return {
			type: types.SET_COMMENT_DESCRIPTION,
			payload
		}
	},
	setPreSetTestDate(payload){
		return {
			type: types.SET_PRE_SET_TEST_DATE,
			payload
		}
	},
	setPreSetTestLength(payload){
		return {
			type: types.SET_PRE_SET_TEST_LENGTH,
			payload
		}
	},
	setPreSetTestIsDays(payload){
		return {
			type: types.SET_PRE_SET_TEST_IS_DAYS,
			payload
		}
	},
	setPreSetTestOccurs(payload){
		return {
			type: types.SET_PRE_SET_TEST_OCCURS,
			payload
		}
	},
	setPreSetTestDescription(payload){
		return {
			type: types.SET_PRE_SET_TEST_DESCRIPTION,
			payload
		}
	},
	setPreSetTestDescriptions(index, description){
		return {
			type: types.SET_PRE_SET_TEST_DESCRIPTIONS,
			payload: {index, description}
		}
	},
	onSetPreSetTestDescriptions(payload) {
		return {
			type: types.ON_SET_PRE_SET_TEST_DESCRIPTIONS,
			payload
		}
	},
	setPreSetTestDescriptionsDate(index, date) {
		return {
			type: types.SET_PRE_SET_DESCRIPTIONS_DATE,
			payload: {index, date}
		}
	},
	onSetPreSetTestDescriptionsDate(payload) {
		return {
			type: types.ON_SET_PRE_SET_DESCRIPTIONS_DATE,
			payload
		}
	},

	onSaveImplementedChange(payload) {
		return {
			type: types.ON_SAVE_IMPLEMENTED_CHANGE,
			payload
		}
	},
	onSaveComment(payload) {
		return {
			type: types.ON_SAVE_COMMENT,
			payload
		}
	},
	onSavePreSetTests(payload) {
		return {
			type: types.ON_SAVE_PRE_SET_TESTS,
			payload
		}
	},
	resetImplementedChanges() {
		return {
			type: types.RESET_IMPLEMENTED_CHANGE
		}
	},
	resetComment() {
		return {
			type: types.RESET_COMMENT
		}
	},
	resetPreSetTests() {
		return {
			type: types.RESET_PRE_SET_TESTS
		}
	},
	onSetPreSetTestOccurs(payload) {
		return {
			type: types.ON_SET_PRE_SET_TEST_OCCURS,
			payload
		}
	},
	setPreSetTestViewId(htmlId, defaultValue) {
		return {
			type: types.SET_PRE_SET_TEST_VIEW_ID,
			payload: {htmlId, defaultValue}
		}
	},
	onSetPreSetTestViewId(payload) {
		return {
			type: types.ON_SET_PRE_SET_TEST_VIEW_ID,
			payload
		}
	},
	setImplementedChangeViewId(htmlId, defaultValue) {
		return {
			type: types.SET_IMPLEMENTED_CHANGE_VIEW_ID,
			payload: {htmlId, defaultValue}
		}
	},
	onSetImplementedChangeViewId(payload) {
		return {
			type: types.ON_SET_IMPLEMENTED_CHANGE_VIEW_ID,
			payload
		}
	},
	setImplementedChangeComparisonId(htmlId, defaultValue) {
		return {
			type: types.SET_IMPLEMENTED_CHANGE_COMPARISON_ID,
			payload: {htmlId, defaultValue}
		}
	},
	onSetImplementedChangeComparisonId(payload) {
		return {
			type: types.ON_SET_IMPLEMENTED_CHANGE_COMPARISON_ID,
			payload
		}
	},
	setImplementedChangeCompareType(htmlId, defaultValue) {
		return {
			type: types.SET_IMPLEMENTED_CHANGE_COMPARE_TYPE,
			payload: {htmlId, defaultValue}
		}
	},
	onSetImplementedChangeCompareType(payload) {
		return {
			type: types.ON_SET_IMPLEMENTED_CHANGE_COMPARE_TYPE,
			payload
		}
	},
	changeShowingDataType(payload) {
		return {
			type: types.CHANGE_SHOWING_DATA_TYPE,
			payload
		}
	},
	rerender() {
		return {
			type: types.RERENDER,
		}
	},
	recalculateDescriptionDates() {
		return {
			type: types.RECALCULATE_DESCRIPTION_DATES,
		}
	},
	onRecalculateDescriptionDates() {
		return {
			type: types.ON_RECALCULATE_DESCRIPTION_DATES,
		}
	},
	setForceRecalc() {
		return {
			type: types.SET_FORCE_RECALC,
		}
	},

	reverseSetImplementedChangeCompareType(htmlId, value) {
		return {
			type: types.REVERSE_SET_IMPLEMENTED_CHANGE_COMPARE_TYPE,
			payload: {htmlId, value}
		}
	},
	reverseSetImplementedChangeComparisonId(htmlId, value) {
		return {
			type: types.REVERSE_SET_IMPLEMENTED_CHANGE_COMPARISON_ID,
			payload: {htmlId, value}
		}
	},
	reverseSetImplementedChangeViewId(htmlId, value) {
		return {
			type: types.REVERSE_SET_IMPLEMENTED_CHANGE_VIEW_ID,
			payload: {htmlId, value}
		}
	},
	reverseSetPreSetTestViewId(htmlId, value) {
		return {
			type: types.REVERSE_SET_PRE_SET_TEST_VIEW_ID,
			payload: {htmlId, value}
		}
	},
	reverseSetImplementedChangeDescription(htmlId, value) {
		return {
			type: types.REVERSE_SET_IMPLEMENTED_CHANGE_DESCRIPTION,
			payload: {htmlId, value}
		}
	},
	reverseSetImplementedChangeTime(htmlId, value) {
		return {
			type: types.REVERSE_SET_IMPLEMENTED_CHANGE_TIME,
			payload: {htmlId, value}
		}
	},
	reverseSetImplementedChangeLength(htmlId, value) {
		return {
			type: types.REVERSE_SET_IMPLEMENTED_CHANGE_LENGTH,
			payload: {htmlId, value}
		}
	},

	deleteImplementedChange(payload) {
		return {
			type: types.DELETE_IMPLEMENTED_CHANGE,
			payload
		}
	},
	deletePreSetTest(payload) {
		return {
			type: types.DELETE_PRE_SET_TEST,
			payload
		}
	},
	deleteComment(payload) {
		return {
			type: types.DELETE_COMMENT,
			payload
		}
	},

	setSearchValue(payload) {
		return {
			type: types.SET_SEARCH_VALUE,
			payload
		}
	},
	setSearchText(payload) {
		return {
			type: types.SET_SEARCH_TEXT,
			payload
		}
	},
	clearSearch() {
		return {
			type: types.CLEAR_SEARCH,
		}
	},
	search() {
		return {
			type: types.SEARCH
		}
	},
	onSearch(payload) {
		return {
			type: types.ON_SEARCH,
			payload
		}
	},
	setSearchBusy() {
		return {
			type: types.SET_SEARCH_BUSY
		}
	},
	clearModalData() {
		return {
			type: types.CLEAR_MODAL_DATA
		}
	},

	genericAction(type, data) {
		return {
			type,
			payload: data
		};
	}
};



// WEBPACK FOOTER //
// ./src/ui/Evidence/redux.js